<template>
  <div>
    <div class="card-container">
      <template v-for="(item, index) in cardConfig">
        <DateCard :card="item" :key="index" style="width:19%;" v-loading="loading.cardLoading"></DateCard>
      </template>
    </div>
    <el-row :gutter="20">
      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard :config="unDeliveryOrder" v-loading="loading.unDeliveryLoading" :style="`height: ${reportHeight};`">
          <span slot="buttons" class="button-wrap">
            <i class="iconfont iconic-setting" @click="updateChart('unship')"></i>
            <i
              class="iconfont iconicon_Import"
              @click="download('unship', 'load.shoplus.bi.undisp.suborder', $t('ocean-bi::order-link::未配货子订单'))"
            ></i>
          </span>
          <div slot="other" class="desc-wrap">
            <p>{{ chartConfig.unship.startDate }}~{{ chartConfig.unship.endDate }}</p>
            <p>{{ $t('ocean-bi::order-link::not-distribution') }}</p>
          </div>
        </reportCard>
      </el-col>

      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard
          :config="waitDeliveryOrder"
          v-loading="loading.waitDeliveryLoading"
          :style="`height: ${reportHeight};`"
        >
          <span slot="buttons" class="button-wrap">
            <i class="iconfont iconic-setting" @click="updateChart('waitship')"></i>
            <i
              class="iconfont iconicon_Import"
              @click="download('unship', 'load.shoplus.bi.waitship.dispcher', $t('ocean-bi::order-link::待发货配货单'))"
            ></i>
          </span>
          <div slot="other" class="desc-wrap">
            <p>{{ chartConfig.waitship.startDate }}~{{ chartConfig.waitship.endDate }}</p>
            <p>{{ $t('ocean-bi::order-link::wait-distribution') }}</p>
          </div>
        </reportCard>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard :config="deliveryOrder" v-loading="loading.DeliveryLoading" :style="`height: ${reportHeight};`">
          <span slot="buttons" class="button-wrap">
            <i class="iconfont iconic-setting" @click="updateChart('onship')"></i>
            <i
              class="iconfont iconicon_Import"
              @click="download('unship', 'load.shoplus.bi.onship.dispcher', $t('ocean-bi::order-link::在途配货单'))"
            ></i>
          </span>
          <div slot="other" class="desc-wrap">
            <p>{{ chartConfig.onship.startDate }}~{{ chartConfig.onship.endDate }}</p>
            <p>{{ $t('ocean-bi::order-link::distributing') }}</p>
          </div>
        </reportCard>
      </el-col>

      <el-col :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard
          :config="hadDeliveryOrder"
          v-loading="loading.hadDeliveryLoading"
          :style="`height: ${reportHeight};`"
        >
          <span slot="buttons" class="button-wrap">
            <i class="iconfont iconic-setting" @click="updateChart('receive')"></i>
            <i
              class="iconfont iconicon_Import"
              @click="download('unship', 'load.shoplus.bi.receive.dispcher', $t('ocean-bi::order-link::妥投配货单'))"
            ></i>
          </span>
          <div slot="other" class="desc-wrap">
            <p>{{ chartConfig.receive.startDate }}~{{ chartConfig.receive.endDate }}</p>
            <p>{{ $t('ocean-bi::order-link::delivered') }}</p>
          </div>
        </reportCard>
      </el-col>
    </el-row>
    <EditDialog v-model="visible" :editChart="editChart" @update="refreshChart"></EditDialog>
  </div>
</template>

<script>
import moment from 'moment'
import setConfig from './setConfig'
import DateCard from '@/components/data-analysis/dateCard'
import reportCard from '@/components/data-analysis/report'
import EditDialog from '../components/editDialog.vue'
import {
  getOrderOverview,
  getUndispSuborder,
  getWaitshipDispcher,
  getOnshipDispcher,
  getReceiveDispcher,
  templateDownload
} from '@/server/etl'
export default {
  name: 'order-link',
  mixins: [setConfig],
  components: { DateCard, reportCard, EditDialog },
  data() {
    return {
      reportHeight: '480px',
      cardConfig: [],
      unDeliveryOrder: {},
      waitDeliveryOrder: {},
      deliveryOrder: {},
      hadDeliveryOrder: {},
      loading: {
        cardLoading: false,
        unDeliveryLoading: false,
        waitDeliveryLoading: false,
        DeliveryLoading: false,
        hadDeliveryLoading: false
      },
      visible: false,
      chartConfig: {
        unship: {
          startDate: moment()
            .subtract(7, 'days')
            .format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          chartType: 'line'
        },
        waitship: {
          startDate: moment()
            .subtract(7, 'days')
            .format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          chartType: 'line'
        },
        onship: {
          startDate: moment()
            .subtract(7, 'days')
            .format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          chartType: 'line'
        },
        receive: {
          startDate: moment()
            .subtract(7, 'days')
            .format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          chartType: 'line'
        }
      },
      editChart: '',
      editType: '',
      timer: null
    }
  },
  created() {
    this.cardConfig = this.getCardConfig()
    this.init()
    this.timer = setInterval(() => {
      this.init()
    }, 600000)
  },
  methods: {
    refreshChart(config) {
      this.chartConfig[this.editType] = config
      switch (this.editType) {
        case 'unship':
          this.getUndispSuborder()
          break
        case 'waitship':
          this.getWaitshipDispcher()
          break
        case 'onship':
          this.getOnshipDispcher()
          break
        case 'receive':
          this.getReceiveDispcher()
          break
      }
    },
    updateChart(type) {
      this.editChart = this.chartConfig[type]
      this.editType = type
      this.visible = true
    },
    async download(type, templateId, name) {
      const { data } = await templateDownload(
        templateId,
        {
          ...this.chartConfig[type],
          orgUnitId: this.merchantId,
        },
        name,
        getCookie('saasToken')
      )
    },
    async getCardInfo() {
      this.loading.cardLoading = true
      const { data } = await getOrderOverview({
        orgUnitId: this.merchantId,
        dt: moment().format('YYYY-MM-DD')
      })
      this.loading.cardLoading = false
      if (data.code === this.$code) {
        if (data.data.datas && data.data.datas.length) {
          this.cardConfig = this.getCardConfig(data.data.datas[0])
        }
      }
    },
    async getUndispSuborder() {
      this.loading.unDeliveryLoading = true
      const { data } = await getUndispSuborder({
        orgUnitId: this.merchantId,
        ...this.chartConfig.unship
      })
      this.loading.unDeliveryLoading = false
      if (data.code === this.$code) {
        this.unDeliveryOrder = this.setUnDeliveryOrder(
          (data.data && data.data.datas) || [],
          this.chartConfig.unship.chartType
        )
      }
    },
    async getWaitshipDispcher() {
      this.loading.waitDeliveryLoading = true
      const { data } = await getWaitshipDispcher({
        orgUnitId: this.merchantId,
        ...this.chartConfig.waitship
      })
      this.loading.waitDeliveryLoading = false
      if (data.code === this.$code) {
        this.waitDeliveryOrder = this.setWaitDeliveryOrder(
          (data.data && data.data.datas) || [],
          this.chartConfig.waitship.chartType
        )
      }
    },
    async getOnshipDispcher() {
      this.loading.DeliveryLoading = true
      const { data } = await getOnshipDispcher({
        orgUnitId: this.merchantId,
        ...this.chartConfig.onship
      })
      this.loading.DeliveryLoading = false
      if (data.code === this.$code) {
        this.deliveryOrder = this.setDeliveryOrder(
          (data.data && data.data.datas) || [],
          this.chartConfig.onship.chartType
        )
      }
    },
    async getReceiveDispcher() {
      this.loading.hadDeliveryLoading = true
      const { data } = await getReceiveDispcher({
        orgUnitId: this.merchantId,
        ...this.chartConfig.receive
      })
      this.loading.hadDeliveryLoading = false
      if (data.code === this.$code) {
        this.hadDeliveryOrder = this.setHadDeliveryOrder(
          (data.data && data.data.datas) || [],
          this.chartConfig.receive.chartType
        )
      }
    },
    init() {
      this.getCardInfo()
      this.getUndispSuborder()
      this.getWaitshipDispcher()
      this.getOnshipDispcher()
      this.getReceiveDispcher()
    }
  },
  computed: {
    merchantId() {
      return this.$store.state.user.merchantId
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  display: flex;
  justify-content: space-between;
}
.button-wrap {
  .iconfont {
    color: #666666;
    margin-left: 10px;
    cursor: pointer;
  }
}
.desc-wrap {
  background: #fafbfc;
  border-radius: 4px;
  padding: 14px;
  color: #8a909d;
  font-size: 12px;
  margin-top: 8px;
  line-height: 2;
}
</style>
